// RxJS 5.5, from the one rxjs copy thruway.js uses too, so these patch the Observable that
// $wamp.thruway.call returns (see previous-report.js).
import {Observable} from 'rxjs/Observable.js';
import 'rxjs/add/observable/forkJoin.js';
import 'rxjs/add/observable/of.js';
import 'rxjs/add/operator/catch.js';
import 'rxjs/add/operator/delay.js';
import 'rxjs/add/operator/map.js';
import 'rxjs/add/operator/retryWhen.js';
import 'rxjs/add/operator/scan.js';
import 'rxjs/add/operator/shareReplay.js';
import 'rxjs/add/operator/timeout.js';
import {notAuthorizedMessage} from './not-authorized.js';

// Ported from the mobile app's src/services/weekTrades.ts. No Angular here, so Node can test it
// (charts/weekTrades.test.mjs).

const TIMEOUT = 25000;
const RETRIES = 2;
const RETRY_DELAY = 1000;

// Past days' boards (org.eggs.get_trades_history), for the flow card's Week view: one call per day,
// each fetched once and shared, since a past day's trades are settled. Their own calls, not
// TradesService.load(date): that service pushes every report it loads into the Trades board's
// shared ReplaySubject and meta.
export default function WeekTradesService($wamp) {
  // Angular makes a factory once per injector, so the page shares it.
  const cache = new Map();

  /** One past day's trades ("YYYY-MM-DD"); null when it can't be had, which isn't kept. */
  function day(date) {
    const cached = cache.get(date);
    if (cached) {
      return cached;
    }
    // $wamp.thruway.call, not $wamp.call (a Promise): the raw result (args, [rows, date] as
    // get_trades sends them) as a cold RxJS 5 Observable, so every retry sends the call again.
    const report = $wamp.thruway.call('org.eggs.get_trades_history', [date])
      .timeout(TIMEOUT)
      // A second apart, as the other services retry; the last error goes on to the catch.
      .retryWhen(errors => errors
        .scan((tries, error) => {
          // A refusal (no trading access) isn't tried again: the same login gets the same answer.
          if (tries >= RETRIES || notAuthorizedMessage(error)) {
            throw error;
          }
          return tries + 1;
        }, 0)
        .delay(RETRY_DELAY))
      .map(res => {
        const [trades] = (res && res.args) || [];
        return Array.isArray(trades) ? trades : [];
      })
      .catch(() => {
        // Only its own entry: the next ask tries again.
        if (cache.get(date) === report) {
          cache.delete(date);
        }
        return Observable.of(null);
      })
      .shareReplay(1);
    cache.set(date, report);
    return report;
  }

  /**
   * The trades of each of `dates` (weekBefore's), in order, once all have answered; null for a day
   * that couldn't be had.
   * @param {string[]} dates
   * @returns {Observable<(Object[]|null)[]>}
   */
  function get(dates) {
    return dates.length ? Observable.forkJoin(dates.map(day)) : Observable.of([]);
  }

  return {get};
}
